<template>
  <span
    ref="el"
    :id="id || null"
    :class="[
      'idtr-editable',
      { 'idtr-editable--inline': inline, 'idtr-editable--error': error },
    ]"
    :data-placeholder="placeholder || null"
    contenteditable="true"
    spellcheck="false"
    @input="onInput"
    @keydown.enter="onEnter"
    @blur="onBlur"
  ></span>
</template>

<script>
export default {
  props: {
    id: {type: String, default: ""},
    value: {type: String, default: ""},
    inline: {type: Boolean, default: false},
    error: {type: Boolean, default: false},
    // No line breaks: Enter is ignored, pasted breaks become spaces, edges are trimmed on blur.
    singleLine: {type: Boolean, default: false},
    // Cleans the typed text (e.g. digits only); the caret moves to the end when it changes the text.
    filter: {type: Function, default: null},
    // Shown on screen while the field is empty (see .idtr-editable[data-placeholder] in the css).
    placeholder: {type: String, default: ""},
  },
  watch: {
    value() {
      this.sync();
    },
  },
  mounted() {
    this.sync();
  },
  methods: {
    sync() {
      const el = this.$refs.el;
      if (el && el.innerText !== this.value) el.innerText = this.value;
    },
    onEnter(event) {
      if (this.singleLine) event.preventDefault();
    },
    onBlur() {
      if (this.singleLine && this.value !== this.value.trim()) {
        this.$emit("input", this.value.trim());
      }
      this.sync();
    },
    onInput(event) {
      const el = event.target;
      let text = el.innerText;
      if (this.singleLine) text = text.replace(/\s*\n\s*/g, " ");
      if (this.filter) text = this.filter(text);
      // Clearing the field leaves a stray <br>, which reads as "\n": treat it as empty so `required` fails.
      if (!text.trim()) {
        text = "";
        if (el.innerHTML !== "") el.innerHTML = "";
      } else if (text !== el.innerText) {
        el.innerText = text;
        this.caretToEnd(el);
      }
      this.$emit("input", text);
    },
    caretToEnd(el) {
      const range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    },
  },
};
</script>
